export default function (state) {
  let form = state;
  let data = {};

  if (form.dates) {
    switch (form.dateType) {
      case 1:
        if (form.dates[0]) data.IssueDateFrom = {Serialized: form.dates[0]};
        if (form.dates[1]) data.IssueDateTo = {Serialized: form.dates[1]};
        break;
      case 2:
        if (form.dates[0]) data.StartDateFrom = {Serialized: form.dates[0]};
        if (form.dates[1]) data.StartDateTo = {Serialized: form.dates[1]};
        break;
      case 3:
        if (form.dates[0]) data.EndDateFrom = {Serialized: form.dates[0]};
        if (form.dates[1]) data.EndDateTo = {Serialized: form.dates[1]};
        break;
      case 4: //дата создания.
        if (form.dates[0]) data.CreateDateFrom = {Serialized: form.dates[0]};
        if (form.dates[1]) data.CreateDateTo = {Serialized: form.dates[1]};
        break;
    }
  }

  if (form.CurrencyIds.length) data.CurrencyIds = form.CurrencyIds;

  if (form.ContragentId) {
    switch (form.ContragentSearchTypeId) {
      case 'client':
        data.ClientId = form.ContragentId;
        break;
      case 'partner':
        data.PartnerId = form.ContragentId;
        break;
      case 'partnerLegal':
        data.PartnerLegalId = form.ContragentId;
        break;
    }
  }

  if (form.SumFrom) data.SumFrom = form.SumFrom;
  if (form.SumTo) data.SumTo = form.SumTo;
  if (form.AvailableSumFrom) data.AvailableSumFrom = form.AvailableSumFrom;
  if (form.AvailableSumTo) data.AvailableSumTo = form.AvailableSumTo;
  if (form.IsUsed) data.IsUsed = form.IsUsed;
  if (form.IsPayed) data.IsPayed = form.IsPayed;
  if (form.Type) data.Type = form.Type;
  if (form.OwnerLegalEntityId) data.OwnerLegalEntityId = form.OwnerLegalEntityId;
  if (form.Number&&form.Number.trim()) data.Number = form.Number.trim();
  //юзаем Number.isInteger для обработки менеджера с id == 0
  //хоть 0-й нулевой менеджер в базах киентво будет "системным", но нам нужно для наших проверок ведь.
  if (Number.isInteger(form.ManagerCreatorId )) data.CreatorManagerId = form.ManagerCreatorId;

  //тим сертификата, 0-все, 1-именной 2-не именной.
  //По умолчанию 0-ль, тоесть не учитывать данное поле при фильтрации.
  if(form.CertificateTypeSelect) {
    if (form.CertificateTypeSelect == 1) {
      data.PersonalCertificate = true;
    } else if (form.CertificateTypeSelect == 2) {
      data.PersonalCertificate = false;
    }
  }

  return data;
}
